<template>

  <!-- Page Sidebar Ends-->
  <div class="page-body">

    <PageTitle title="Dashboard" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row size-column">

        <div class="col-xxl-9 box-col-12">
          <div class="row">
            <div class="col-xl-3 col-sm-6">
              <router-link to="gatepass">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-project border-b-primary border-2"><span
                      class="f-light f-w-500 f-14">Today Schedule</span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_gatepasses.length }}</h2>
                      </div>
                      <div class="product-sub bg-primary-light">

                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-6">
              <router-link to="gatepass">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Progress border-b-warning border-2"> <span
                      class="f-light f-w-500 f-14">Today Check-In</span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_gatepasses_active.length }}</h2>
                      </div>
                      <div class="product-sub bg-warning-light">

                      </div>
                    </div>

                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-6">
              <router-link to="gatepass">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-Complete border-b-secondary border-2"><span
                      class="f-light f-w-500 f-14">Today Check-Out</span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_gatepasses_done.length }}</h2>
                      </div>
                      <div class="product-sub bg-secondary-light">

                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
            <div class="col-xl-3 col-sm-6">
              <router-link to="vehicalrequest">
                <div class="card o-hidden small-widget">
                  <div class="card-body total-upcoming"><span class="f-light f-w-500 f-14">Today Vehicle-Req</span>
                    <div class="project-details">
                      <div class="project-counter">
                        <h2 class="f-w-600">{{ today_veh_req.length }}</h2>
                      </div>
                      <div class="product-sub bg-light-light">

                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <!--<div class="col-xxl-9 box-col-12 card">-->
        <!-- <div class="card-header">-->
        <!--    <h2 class="card-title">Department Meeting Schedule</h2>-->
        <!-- </div>-->
        <!--  <div class="card-body row">-->

        <!--    <div class="col-12 col-md-4" v-for="(item, index)  in all_reservations" :key="item.gatepassid">-->


        <!--      <div class="accordion-item">-->
        <!--      <h2 class="accordion-header" :id="index+'_acc'">-->
        <!--        <button class="accordion-button collapsed accordion-light-primary txt-primary" type="button"-->
        <!--          data-bs-toggle="collapse" :data-bs-target="'#'+'collapse_'+index" aria-expanded="false"-->
        <!--          aria-controls="collapseOne"> {{ item.date }}<i class="svg-color"-->
        <!--            data-feather="chevron-down"></i></button>-->
        <!--      </h2>-->
        <!--      <div class="accordion-collapse collapse " :id="'collapse_'+index" :aria-labelledby="index+'_acc'"-->
        <!--        data-bs-parent="#simpleaccordion">-->
        <!--        <div class="accordion-body">-->
        <!--          <div v-for="(row, index)  in item.schedule" :class="(row.status == 2) ? 'meet_success' : 'meet_pending'">-->
        <!--          <div><b>{{ index + 1 }}. {{ row.emp_name }}</b> <span class="badge badge-info">{{ row.shedule_time }}</span>-->
        <!--          </div>-->
        <!--          <div>Purpose : {{ row.purpose }} <span class="badge badge-warning">{{ row.room_details }}</span></div>-->
        <!--          <hr>-->
        <!--        </div>-->
        <!--        </div>-->
        <!--      </div>-->
        <!--    </div>-->


             
        <!--    </div>-->

        <!--  </div>-->
        <!--</div>-->
      </div>
    </div>
    <!-- Container-fluid Ends-->
    

    <div>
      <!-- Calendar header to show "2024 Sep" and toggle the view -->
      <div class="calendar-header">
        <!-- Clicking the button toggles between year view and month view -->
        <button class="badge-primary text-white" @click="showYearView = !showYearView">{{ currentYear }} {{ currentMonthName }}</button>
      </div>
    
      <!-- Month view (shows the current month only if not in year view) -->
      <div v-if="!showYearView" class="calendar-month-view">
        <table>
          <thead>
            <tr>
              <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="week in calendarDays" :key="week[0].date">
              <td v-for="day in week" :key="day.date" 
                  :class="{ 'empty-day': !day.isInMonth, 
                            'today': isToday(day), 
                            'selected': isSelected(day), 
                            'has-reservation': hasReservation(day) }"
                  @click="selectDay(day)">
                {{ day.isInMonth ? day.date.getDate() : '' }}
                <!-- Reservation Details -->
                <div class="card-body row" v-if="isSelected(day)">
                  <div class="col-12 col-md-4" v-for="(item, index) in selectedReservations" :key="item.gatepassid">
                    <div class="accordion-item">
                      <h2 class="accordion-header" :id="'accordion-header-' + index">
                        <!-- Add dynamic class based on selected date -->
                        <button
                          :class="{
                            'accordion-button': true,
                            'collapsed': selectedDay !== item.date,
                            'accordion-light-primary txt-primary': true,
                            'highlighted': selectedDay === item.date
                          }"
                          type="button"
                          data-bs-toggle="collapse"
                          :data-bs-target="'#collapse_' + index"
                          aria-expanded="false"
                          :aria-controls="'collapse_' + index"
                          @click="toggleCollapse(item.date, index)"
                        >
                          {{ day.date.getDate() }}
                          <i class="svg-color" data-feather="chevron-down"></i>
                        </button>
                      </h2>
                      <div
                        class="accordion-collapse collapse"
                        :id="'collapse_' + index"
                        :aria-labelledby="'accordion-header-' + index"
                        data-bs-parent="#simpleaccordion"
                      >
                        <div class="accordion-body">
                          <div
                            v-for="(row, i) in item.schedule"
                            :key="i"
                            :class="row.status == 2 ? 'meet_success' : 'meet_pending'"
                          >
                            <div>
                              <b>{{ i + 1 }}. {{ row.emp_name }}</b>
                              <span class="badge badge-info">{{ row.shedule_time }}</span>
                            </div>
                            <div>
                              Purpose: {{ row.purpose }}
                              <span class="badge badge-warning">{{ row.room_details }}</span>
                            </div>
                            <hr />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    
      <!-- Year view (shows all 12 months) -->
      <div v-if="showYearView" class="calendar-year-view">
        <div v-for="(month, index) in months" :key="index" class="month-view">
          <div class="month-name">{{ month }}</div>
          <table @click="changeMonth(index)">
            <thead>
              <tr>
                <th v-for="day in daysOfWeek" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="week in generateCalendar(currentYear, index)" :key="week[0].date">
                <td v-for="day in week" :key="day.date" :class="{ 'empty-day': !day.isInMonth,'has-reservation': hasReservation(day) }">
                  {{ day.isInMonth ? day.date.getDate() : '' }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    
    
    
    

  </div>



</template>
<style scoped>
.meet_success{
  background: #97ff8d;
  padding: 5px;
}.meet_pending{
  background: #f7f7f7;
  padding: 5px;
}
.accordion-item{
  padding: 5px;
}


.calendar-header {
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
}

.calendar-month-view table {
  width: 100%;
  border-collapse: collapse;
}

.calendar-month-view th,
.calendar-month-view td {
  padding: 10px;
  text-align: center;
  border: 1px solid #ddd;
}

.empty-day {
  color: #ccc;
}
.badge-primary{
  display: block;
}
.has-reservation {
    background-color: #4caf50; /* Green highlight for dates with reservations */
    color: white;
  }
.today {
  background-color: #ffeb3b; /* Highlight today with yellow */
  color: #000;
  font-weight: bold;
}
.highlighted {
    background-color: #007bff;
    color: white;
  }
.selected {
  background-color: #4caf50; /* Highlight the selected day with green */
  color: #fff;
  font-weight: bold;
}
.calendar-year-view {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Display 3 months per row */
  gap: 20px;
}

.month-view {
  text-align: center;
}

.month-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.month-view table {
  width: 100%;
  border-collapse: collapse;
}

.month-view th,
.month-view td {
  padding: 5px;
  text-align: center;
  border: 1px solid #ddd;
}
  </style>
<script>
import PageTitle from '@/components/PageTitle.vue';
import axios from 'axios';

export default {
  name: 'HomeView',
  components: {
    PageTitle
  },
  mounted() {
    this.getDashboard();
  },
  data() {
    const currentDate = new Date();
    return {
      emp: [name => '', dept => '', empcode => '', role => ''],
      today_gatepasses: [],
      today_gatepasses_active: [],
      today_gatepasses_done: [],
      today_veh_req: [],
      otp: '',
      all_reservations: [],
      selectedReservations: [],
      currentMonth: currentDate.getMonth(), // Get current month (0-indexed, e.g., 0 = January)
      currentYear: currentDate.getFullYear(), // Get current year
      today: currentDate,
      selectedDay: null, // Track the selected day
      showYearView: false, // Controls if year view is shown
      daysOfWeek: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      months: [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug',
        'Sep', 'Oct', 'Nov', 'Dec'
      ],

    }
  },
  computed: {
    // Get the current month's name based on the currentMonth index
    currentMonthName() {
      return this.months[this.currentMonth];
    },
    // Generate days for the current month
    calendarDays() {
      return this.generateCalendar(this.currentYear, this.currentMonth);
    }
  },
  methods: {
    hasReservation(day) {
    // Check if a date in calendar matches any reservation date
    return this.all_reservations.some(reservation => {
      const reservationDate = new Date(reservation.date);
      return (
        reservationDate.getDate() === day.date.getDate() &&
        reservationDate.getMonth() === day.date.getMonth() &&
        reservationDate.getFullYear() === day.date.getFullYear()
      );
    });
  },
  toggleCollapse(reservationDate, index) {
    const targetId = 'collapse_' + index;
    const target = document.getElementById(targetId);

    if (this.selectedDay && new Date(reservationDate).toDateString() === this.selectedDay.toDateString()) {
      // Toggle the collapse state
      const bsCollapse = new bootstrap.Collapse(target, {
        toggle: true
      });
    } else {
      this.selectDay(new Date(reservationDate)); // If different day, select it
    }
  },
    // Generate the days for the given month and year
    generateCalendar(year, month) {
      const startDay = new Date(year, month, 1).getDay();
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      let calendar = [];
      let week = [];
      let dayCounter = 1;

      // Generate trailing days for the previous month
      for (let i = 0; i < startDay; i++) {
        week.push({ isInMonth: false, date: new Date(year, month, dayCounter++) });
      }

      // Generate current month's days
      for (let i = 1; i <= daysInMonth; i++) {
        week.push({ isInMonth: true, date: new Date(year, month, i) });
        if (week.length === 7) {
          calendar.push(week);
          week = [];
        }
      }

      // Fill remaining week with next month's leading days
      while (week.length < 7) {
        week.push({ isInMonth: false, date: new Date(year, month + 1, dayCounter++) });
      }

      calendar.push(week);
      return calendar;
    },
    isToday(day) {
      // Check if the given day is today's date
      const today = this.today;
      return (
        day.isInMonth &&
        day.date.getDate() === today.getDate() &&
        day.date.getMonth() === today.getMonth() &&
        day.date.getFullYear() === today.getFullYear()
      );
    },
    selectDay(day) {
      // Set the selected day
      if (day.isInMonth) {
        this.selectedDay = day.date;

        // Filter reservations based on the selected date
      const selectedDate = `${this.selectedDay.getFullYear()}-${(this.selectedDay.getMonth() + 1).toString().padStart(2, '0')}-${this.selectedDay.getDate().toString().padStart(2, '0')}`;
      this.selectedReservations = this.all_reservations.filter(reservation => reservation.date === selectedDate);
      }
    },
    isSelected(day) {
      // Check if the day is the selected day
      return (
        this.selectedDay &&
        day.isInMonth &&
        day.date.getDate() === this.selectedDay.getDate() &&
        day.date.getMonth() === this.selectedDay.getMonth() &&
        day.date.getFullYear() === this.selectedDay.getFullYear()
      );
    },
    changeMonth(monthIndex) {
      this.currentMonth = monthIndex;
      this.showYearView = false;
    },
    getDashboard() {
      var self = this;

      if (localStorage['token']) {
        axios.post('getDashboard', { token: localStorage['token'] }).then(function (response) {
          if (response.data.is == 1) {
            self.emp = response.data.emp;
            self.today_gatepasses = response.data.today_gatepasses;
            self.today_gatepasses_active = response.data.today_gatepasses_active;
            self.today_gatepasses_done = response.data.today_gatepasses_done;
            self.today_veh_req = response.data.today_veh_req;
            self.all_reservations = response.data.all_reservations;
          } else {
          }
        });
      }
    },
  }
}
</script>
